<template>
  <div class="form-certification">
    <edit-table
      :option="option"
      :data="salaryData"
      @submit-add="handleSubmit"
      @submit-edit="handleSubmit"
      @refresh-change="refreshChange"
    />
  </div>
</template>

<script>
import EditTable from '@/components/editTable/index.vue';
import WORKER from '@/api/worker/salary';
import { deepClone } from '@/util/util'

export default {
  components: {
    EditTable,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    currentId: {
      type: String,
      default: '',
    },
    detailType: {
      type: String,
      default: 'view',
    },
  },
  data() {
    return {
      hasToStringTypes: ['select'],
      salaryData: [],
    }
  },
  computed: {
    option() {
      const option = {
        addBtn: false,
        delBtn: false,
        editBtn: false,
        columns: [
          {
            label: this.i18n('basicSalary'),
            field: 'salaryCategoryName',
            class: 'table-td',
            disabled: true,
          },
          {
            label: this.i18n('money'),
            field: 'salaryValue',
            class: 'table-td',
          },
        ],
      }
      return option
    },
    form() {
      const res = []

      this.data.forEach(row => {
        const temp = row
        this.option.columns.forEach(item => {
          if (this.hasToStringTypes.indexOf(item.type) !== -1) {
            temp[item.field] = row[item.field].toString()
          }
        });
        res.push(temp)
      })
      return res
    },
  },
  mounted() {
    this.onLoad()
  },
  methods: {
    // 国际化
    i18n(param) {
      return this.$t(`_staff.labelEmployment.${param}`)
    },
    handleSubmit(done, row) {
      const params = deepClone(row)
      const { columns } = this.option
      const items = columns && columns.reduce((v, c) => {
        const vv = v
        vv[c.field] = params[c.field]
        return v
      }, {})
      WORKER.update({ id: params.id, ...items }).then(res => {
        this.reLoad().then(() => {
          done()
        })
      })
    },
    handleRowDel(done, row) {
      console.log(row, 'handleRowDel');
    },
    reLoad() {
      return new Promise(resolve => {
        WORKER.getList(1, -1, { workerId: this.currentId }).then(res => {
          console.log(res.data.data.records, 'data+++')
          this.salaryData = res.data.data.records
          resolve()
        })
      })
    },
    refreshChange() {

    },
    onLoad() {
      this.salaryData = deepClone(this.form)
    },
  },
}
</script>
<style lang="scss">
.form-certification{
  &-top{
    text-align: right;
  }
  .table-td{
    text-align: center;
    line-height: 50px;
    &-sm{
      width: 200px;
    }
  }
}
</style>
